import type { HTTPService } from "@soft-db/http";
import {
	DashboardApi,
	DistributorApi,
	GroupApi,
	RecipientsApi,
	ReportApi,
	SpaceApi,
	UserApi,
	WeeklyLimitApi,
} from "./api";
import { AlertApi } from "./api/alert-api";
import { ArchiveApi } from "./api/archive-api";
import { ArchivistApi } from "./api/archivist-api";
import { AuditApi } from "./api/audit-api";
import { AuthApi } from "./api/auth-api";
import { CurrentUserApi } from "./api/current-user.api";
import { DynamicImageApi } from "./api/dynamic-image.api";
import { ExternalRecipientApi } from "./api/external-recipient";
import { ProjectApi } from "./api/project-api";
import { PublicPageApi } from "./api/public-page.api";
import { SiteApi } from "./api/site-api";
import { StationApi } from "./api/station-api";
import { StationHealthApi } from "./api/station-health-api";
import { VibrationCriteriaApi } from "./api/vibration-criteria-api";

interface ApiConstructor<T> {
	new (http: HTTPService): T;
}

export class MonitoringApi {
	private _apiStore = new Map<ApiConstructor<any>, any>();

	constructor(private _http: HTTPService) {}

	auth() {
		return this._getApi(AuthApi);
	}

	currentUser() {
		return this._getApi(CurrentUserApi);
	}

	project() {
		return this._getApi(ProjectApi);
	}

	stationHealth() {
		return this._getApi(StationHealthApi);
	}

	vibrationCriterias() {
		return this._getApi(VibrationCriteriaApi);
	}

	archivist() {
		return this._getApi(ArchivistApi);
	}

	alert() {
		return this._getApi(AlertApi);
	}

	station() {
		return this._getApi(StationApi);
	}

	dashboard() {
		return this._getApi(DashboardApi);
	}

	group() {
		return this._getApi(GroupApi);
	}

	user() {
		return this._getApi(UserApi);
	}

	publicPage() {
		return this._getApi(PublicPageApi);
	}

	dynamicImage() {
		return this._getApi(DynamicImageApi);
	}

	archive() {
		return this._getApi(ArchiveApi);
	}

	weeklyLimit() {
		return this._getApi(WeeklyLimitApi);
	}

	audit() {
		return this._getApi(AuditApi);
	}

	space() {
		return this._getApi(SpaceApi);
	}

	distributor() {
		return this._getApi(DistributorApi);
	}

	site() {
		return this._getApi(SiteApi);
	}

	recipients() {
		return this._getApi(RecipientsApi);
	}

	externalRecipients() {
		return this._getApi(ExternalRecipientApi);
	}

	report() {
		return this._getApi(ReportApi);
	}

	private _getApi<T>(clazz: ApiConstructor<T>): T {
		let api = this._apiStore.get(clazz) as T | null;
		if (!api) {
			api = new clazz(this._http);
			this._apiStore.set(clazz, api);
		}

		return api;
	}
}
